// @ts-check

import { store } from '@/store'

import { service } from '@/core/constants'
import {
  AUTHENTICATION_REQUIRED,
  HIDE_TITLE_ON_MOBILE,
  IS_IN_MAIN_NAV,
  ROUTE_NAME
} from '@/router/meta'

/** @type {import('vue-router').RouteRecordRaw} */
export const listIncomesRoute = {
  path: '/incomes',
  name: 'incomes',
  component: () => import('@/views/income/IncomeIndex.vue'),
  meta: {
    [AUTHENTICATION_REQUIRED]: true,
    [IS_IN_MAIN_NAV]: true,
    icon:
      process.env.VUE_APP_SERVICE === service.TLP
        ? '$invoice-text-outline'
        : '$cash-plus',
    [ROUTE_NAME]: 'incomes'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const createIncomeRoute = {
  path: '/incomes/new',
  name: 'new_income',
  component: () => import('@/views/income/IncomeCreate.vue'),
  beforeEnter: (to, from, next) => {
    // Clear assignment before entering
    store.commit('assignment/clearData')
    next()
  },
  meta: {
    [AUTHENTICATION_REQUIRED]: true,
    [IS_IN_MAIN_NAV]: false,
    [ROUTE_NAME]: 'new_income',
    [HIDE_TITLE_ON_MOBILE]: true
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const editIncomeRoute = {
  path: '/incomes/:id',
  name: 'edit_income',
  component: () => import('@/views/income/IncomeEdit.vue'),
  beforeEnter: (to, from, next) => {
    // Clear assignment before entering
    store.commit('assignment/clearData')
    next()
  },
  meta: {
    [AUTHENTICATION_REQUIRED]: true,
    [IS_IN_MAIN_NAV]: false,
    [ROUTE_NAME]: 'edit_income',
    [HIDE_TITLE_ON_MOBILE]: true
  }
}

/** @type {import('vue-router').RouteRecordRaw[]} */
export const incomeRoutes = [
  ...(process.env.VUE_APP_SERVICE === service.TLP
    ? [listIncomesRoute]
    : [listIncomesRoute, createIncomeRoute, editIncomeRoute])
]

export default incomeRoutes
